module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0039.jpg?v=65d0298a";